import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[focusMe]',
  standalone: true,
})
export class FocusMeDirective {

  @Input() set focusMe(trigger: boolean | { delay: number }) {
    if (trigger) {
      const delay = typeof trigger === 'object' ? trigger.delay : 0;
      setTimeout(() => {
        this.elementRef.nativeElement.focus();
      }, delay);
    }
  }

  constructor( private elementRef: ElementRef) {
  }

}